/** API helpers for per-entreprise accueilv2 sidebar. */
export const SIDEBAR_API = {
  MY: "/entreprise/mySidebar/",
  CLICK: "/entreprise/sidebarClick/",
} as const;
